import z from 'zod';
import { defineObject } from 'sanity-typed-queries';
import labeledLink from './labeledLink.js';
import donationBoxSettingsModalInfo from './donationBoxSettingsModalInfo.js';
var schema = defineObject('donationBoxSettings', {
    title: {
        type: 'string',
        title: 'Title',
        validation: function validation(Rule) {
            return Rule.required();
        }
    },
    subtitle: {
        type: 'string',
        title: 'Subtitle'
    },
    onetimeUrlFormat: {
        type: 'url',
        title: 'One-time URL format',
        description: 'Use {value} placeholder to insert selected value (eg: https://donate.com/?value={value})'
    },
    monthlyUrlFormat: {
        type: 'url',
        title: 'Monthly URL format',
        description: 'Use {value} placeholder to insert selected value (eg: https://donate.com/?value={value})'
    },
    modalInfo: {
        type: 'donationBoxSettingsModalInfo',
        title: 'Modal info'
    },
    additionalAction: {
        title: 'Additional action',
        type: 'labeledLink'
    }
}, [
    labeledLink.schema.labeledLink,
    donationBoxSettingsModalInfo.schema.donationBoxSettingsModalInfo
]);
var validator = z.object({
    _type: z.literal('donationBoxSettings'),
    title: z.string().optional(),
    subtitle: z.string().optional(),
    onetimeUrlFormat: z.string().optional(),
    monthlyUrlFormat: z.string().optional(),
    modalInfo: donationBoxSettingsModalInfo.validator.optional(),
    additionalAction: labeledLink.validator.optional()
});
schema.donationBoxSettings;
export default {
    schema: schema,
    validator: validator
};

//# sourceMappingURL=donationBoxSettings.js.map